
import React from 'react';
import { cn } from '@/lib/utils';

interface TaskCardTitleProps {
  title: string;
  isCompleted: boolean;
  onCheckboxChange?: (checked: boolean) => void;
  handleClickStopPropagation?: (e: React.MouseEvent) => void;
}

const TaskCardTitle: React.FC<TaskCardTitleProps> = ({
  title,
  isCompleted,
  onCheckboxChange,
  handleClickStopPropagation,
}) => {
  return (
    <div className="flex items-center min-w-0 w-full">
      {/* Checkbox spacing - matches the positioned checkbox size */}
      <div className="flex-shrink-0 w-6 h-6 mr-2"></div>
      
      {/* Task title - strict overflow handling */}
      <div className="flex-1 min-w-0" style={{ overflow: 'hidden' }}>
        <h3 
          className={cn(
            "text-sm font-medium transition-all",
            isCompleted && "text-muted-foreground line-through"
          )}
          style={{ 
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
          title={title} // Show full title on hover
        >
          {title}
        </h3>
      </div>
    </div>
  );
};

export default TaskCardTitle;
